import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './screens/Home';
import Header from './components/Header/Header';
import About from './screens/About';
import Services from './screens/Services';
import Insights from './screens/Insights';
import Contact from './screens/Contact';
import SpecificService from './screens/SpecificService';
import ScrollToTop from './ScrollToTop';
import servicesContent from './data/servicesContent';
import SpecificInsight from './screens/SpecificInsight';
import AdminLogin from './screens/AdminLogin';
import AdminInsight from './screens/AdminInsight';
import AuthRoute from './routes/AuthRoute';

function App() {

  return (
    <div>
      <ScrollToTop />
      <Header />
      <div className="eo-spacer">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/insights/:slug" element={<SpecificInsight />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/contact" element={<Contact />} />
          
          <Route path="/admin" element={<AdminLogin />} />
          <Route element={<AuthRoute />}>
          <Route path="/admin/insight" element={<AdminInsight />} />
          </Route>
          
          <Route path="/services/sunglasses"
            element={
              <SpecificService
                collections={servicesContent.sunglasses.collections}
                aboutHeroContent={servicesContent.sunglasses.aboutHeroContent}
                VisionSectionContent={servicesContent.sunglasses.VisionSectionContent}
                cardContent={servicesContent.sunglasses.cardContent}
                cardContentHeading={servicesContent.sunglasses.cardContentHeading}
                whyChooseContent={servicesContent.sunglasses.whyChooseContent}
                heading={servicesContent.sunglasses.heading}
                
              />}
          />
          <Route path="/services/eye-exam"
            element={
              <SpecificService
                collections={servicesContent.eyeExam.collections}
                aboutHeroContent={servicesContent.eyeExam.aboutHeroContent}
                VisionSectionContent={servicesContent.eyeExam.VisionSectionContent}
                cardContent={servicesContent.eyeExam.cardContent}
                cardContentHeading={servicesContent.eyeExam.cardContentHeading}
                whyChooseContent={servicesContent.eyeExam.whyChooseContent}
                heading={servicesContent.eyeExam.heading}
              />}
          />
          <Route path="/services/safety-glasses"
            element={
              <SpecificService
                collections={servicesContent.safetyGlasses.collections}
                aboutHeroContent={servicesContent.safetyGlasses.aboutHeroContent}
                VisionSectionContent={servicesContent.safetyGlasses.VisionSectionContent}
                cardContent={servicesContent.safetyGlasses.cardContent}
                cardContentHeading={servicesContent.safetyGlasses.cardContentHeading}
                whyChooseContent={servicesContent.safetyGlasses.whyChooseContent}
                heading={servicesContent.safetyGlasses.heading}
                pageText={"safety-glasses"}
              />}
          />
          <Route path="/services/eye-glasses"
            element={
              <SpecificService
                collections={servicesContent.eyeGlasses.collections}
                aboutHeroContent={servicesContent.eyeGlasses.aboutHeroContent}
                VisionSectionContent={servicesContent.eyeGlasses.VisionSectionContent}
                cardContent={servicesContent.eyeGlasses.cardContent}
                cardContentHeading={servicesContent.eyeGlasses.cardContentHeading}
                whyChooseContent={servicesContent.eyeGlasses.whyChooseContent}
                whyChooseContentHeading={servicesContent.eyeGlasses.whyChooseContentHeading}
                heading={servicesContent.eyeGlasses.heading}
              />}
          />
          <Route path="/services/sports-goggles"
            element={
              <SpecificService
                collections={servicesContent.sportsGoggles.collections}
                aboutHeroContent={servicesContent.sportsGoggles.aboutHeroContent}
                VisionSectionContent={servicesContent.sportsGoggles.VisionSectionContent}
                cardContent={servicesContent.sportsGoggles.cardContent}
                cardContentHeading={servicesContent.sportsGoggles.cardContentHeading}
                whyChooseContent={servicesContent.sportsGoggles.whyChooseContent}
                whyChooseContentHeading={servicesContent.sportsGoggles.whyChooseContentHeading}
                heading={servicesContent.sportsGoggles.heading}
                pageText={"sports-goggles"}
              />}
          />
          <Route path="/services/contact-lenses"
            element={
              <SpecificService
                collections={servicesContent.contactLenses.collections}
                aboutHeroContent={servicesContent.contactLenses.aboutHeroContent}
                VisionSectionContent={servicesContent.contactLenses.VisionSectionContent}
                cardContent={servicesContent.contactLenses.cardContent}
                cardContentHeading={servicesContent.contactLenses.cardContentHeading}
                whyChooseContent={servicesContent.contactLenses.whyChooseContent}
                whyChooseContentHeading={servicesContent.contactLenses.whyChooseContentHeading}
                heading={servicesContent.contactLenses.heading}
                pageText={"contact-lenses"}
              />}
          />
        </Routes>
      </div>
    </div >
  );
}

export default App;
